/* main react */
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';

/* reducer, selector, action */
import { clearSignInErrorMessage, signInCredentialStart } from '../../_actions/authentication.actions';
import { selectErrorMessage, selectGetAccountListSuccess, selectSignInStatus } from '../../_selectors/authentication.selectors';
import { createStructuredSelector } from 'reselect';
import Spinner from '../../_components/spinner/spinner.component';

const ADLogin = (props) => {

  const {
    signInCredentialStart,
    signInStatus,
    signInErrorMessage,
    clearSignInErrorMessage,
    getAccountListSuccess,
  } = props;
  const history = useHistory();

  useEffect(() => {
    if (signInStatus && getAccountListSuccess) {
      history.push('/main')
      return
    }
    if (!signInStatus) {
      if (signInErrorMessage) {
        clearSignInErrorMessage()
      }
      signInCredentialStart({history})
    }
  }, [signInStatus, getAccountListSuccess]);

  return (
    <div className='text-center mt-5'>
      {
        signInErrorMessage &&
        <h1 className='mb-0'>{signInErrorMessage}</h1>
      }
      {
        !(getAccountListSuccess && signInErrorMessage) &&
        <>
          <h1 className='mb-0'>กำลังเข้าสู่ระบบ กรุณารอสักครู่</h1>
          <Spinner />
        </>
      }
    </div>
  );
};

const mapStateToProps = createStructuredSelector({
  signInStatus: selectSignInStatus,
  signInErrorMessage: selectErrorMessage,
  getAccountListSuccess: selectGetAccountListSuccess,
});
const mapDispatchToProps = (dispatch) => ({
  signInCredentialStart: (payload) => dispatch(signInCredentialStart(payload)),
  clearSignInErrorMessage: () => dispatch(clearSignInErrorMessage()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ADLogin);
